module.exports = __webpack_public_path__ + "4c4b45781e7a059a5b1c2103f12d4b91.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/svg/card.svg
// module id = 525
// module chunks = 0